varying vec3 vPosition;

void main()
{
    float mask = distance(gl_PointCoord, vec2(0.5));
    
    // Create a hard edge instead of a smoothstep
    if(mask > 0.5) discard; 

    vec3 color = (vPosition + 75.0) / 150.0;
    
    // No need for smooth mask alpha, just solid 1.0
    gl_FragColor = vec4(color, 1.0); 
}